import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import authReducer from "./slices/auth";
import classReducer from "./slices/class";
import modalReducer from "./slices/modal";
import loaderReducer from "./slices/loader";
import bookingReducer from "./slices/booking";
import paymentReducer from "./slices/payment";
import { mapReducer } from "./slices/map/mapSlice";
import partnerReducer from "./slices/partner";
import guestReducer from "./slices/guest";
import advanceModalReducer from "./slices/advanceModal";
import contentfulReducer from "./slices/contentful";
import DeliveryReducer from "./slices/delivery";
import deliveryReducer from "./slices/delivery";

const appReducer = combineReducers({
  form: formReducer,

  auth: authReducer,
  modal: modalReducer,
  advanceModal: advanceModalReducer,
  classes: classReducer,
  loading: loaderReducer,
  payment: paymentReducer,
  booking: bookingReducer,
  map: mapReducer,
  partner: partnerReducer,
  guest: guestReducer,
  contentful: contentfulReducer,
  delivery: deliveryReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "auth/logout") {
    const form = state.form;
    const classes = state.classes;
    const payment = state.payment;

    // Keep checkout amount/widgets when logging out on payment-form
    state = { form, classes, payment };
  }

  return appReducer(state, action);
};

export default rootReducer;
